import { useCallback, useState } from 'react'
import { useInterval } from 'react-use'
import { useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'

import Styles from './InviteTeam.module.scss'

import { ReactComponent as LinkIcon } from 'assets/icons/link16.svg'
import { ReactComponent as GoogleLogo } from 'components/GoogleButton/GoogleLogo.svg'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Modal } from 'almanac-ui/Modal'
import { frontendOrigin } from 'utils/frontendOrigin'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { FetchSubscriptionResponse } from 'api/clients/WorkspaceClient'
import { Button } from 'blaze-ui/Button'
import { Check } from 'blaze-ui/icons/16'

export const InviteByLink = ({
  showImportScreen,
  currentPlan,
}: {
  showImportScreen: () => void
  currentPlan: FetchSubscriptionResponse
}) => {
  const workspace = useCurrentWorkspace()
  const [isCopied, setIsCopied] = useState(false)
  const location = useLocation()

  useInterval(() => {
    if (isCopied) {
      setIsCopied(false)
    }
  }, 3000)

  const selectInput = useCallback((inputElement: any) => {
    if (inputElement) {
      setTimeout(() => {
        inputElement.select()
      }, 50)
    }
  }, [])

  if (!workspace) return null

  const shareLink = `${frontendOrigin()}/invite/workspace/${workspace.invitation_token}`

  const copyShareLink = () => {
    if (!workspace) {
      showToastMessage('Unable to copy share link', 'error')
      return
    }
    navigator.clipboard.writeText(shareLink)
    setIsCopied(true)
    showToastMessage('Link Copied!', 'success')
  }

  return (
    <>
      <div className={Styles.linkContainer}>
        <div className={Styles.shareLinkContainer}>
          <div className={Styles.shareLinkHeader}>Share link</div>
          <div className={Styles.copyLinkContainer}>
            <input value={shareLink} ref={selectInput} readOnly />
            <Button
              frontIcon={isCopied ? Check : LinkIcon}
              size="md"
              onPress={copyShareLink}
              isDisabled={!workspace?.invitation_token_enabled}
            >
              <span className={Styles.linkButtonText}>{isCopied ? 'Copied!' : 'Copy link'}</span>
            </Button>
          </div>
        </div>

        <span className={Styles.subtext}>
          {!workspace?.invitation_token_enabled && (
            <span data-testid="enable-share-link-message">
              Share link must be enabled in <Link to={`${location.pathname}?settings=members`}>settings</Link>.
            </span>
          )}
        </span>
      </div>
      <div className={Styles.dividerContainer}>
        <div className={Styles.divider}></div>
        <p>Or</p>
        <div className={Styles.divider}></div>
      </div>
      <div className={Styles.inviteByLinkFooter}>
        <Modal.FooterContent slot="center">
          <Button frontIcon={GoogleLogo} size="xl" onPress={showImportScreen} variant="secondary">
            Invite by Google Contacts
          </Button>
        </Modal.FooterContent>
      </div>
    </>
  )
}
